<div class="full-page-loading-spinner" data-testid='spinner' [ngClass]="{'show-spinner': showSpinner}">
    <div class="spinner1"></div>
</div>
